export default "__VITE_ASSET__5e628e63__"